

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { createUser } from "../redux/actions/UserActions";
// import { fetchDistricts, fetchMunicipalities } from "../redux/actions/locationActions";

// const AddUser = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//     dob: "",
//     doj: "",
//     municipality: "",
//     municipality_id: "",
//     designation: "",
//     district: "",
//     district_id: "",
//   });

//   const dispatch = useDispatch();

//   const { creating, error } = useSelector((state) => state.User);

//   // ✅ Match CreateHoliday logic here
//   const { districts = [], municipalities = [] } = useSelector((state) => state.location || {});

//   useEffect(() => {
//     dispatch(fetchDistricts());
//     dispatch(fetchMunicipalities());
//   }, [dispatch]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleDistrictChange = (e) => {
//     const district_id = e.target.value;
//     const selected = districts.find((d) => d.id === parseInt(district_id));
//     setFormData((prev) => ({
//       ...prev,
//       district_id,
//       district: selected?.name || "",
//       municipality_id: "",
//       municipality: "",
//     }));
//   };

//   const handleMunicipalityChange = (e) => {
//     const municipality_id = e.target.value;
//     const selected = municipalities.find((m) => m.id === parseInt(municipality_id));
//     setFormData((prev) => ({
//       ...prev,
//       municipality_id,
//       municipality: selected?.name || "",
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(createUser(formData));
//   };

//   return (
//     <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
//       <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-lg">
//         <h1 className="text-2xl font-bold text-gray-800 mb-6">Add User</h1>

//         {error && (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
//             Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
//           {[
//             { label: "Name", name: "name", type: "text" },
//             { label: "Email", name: "email", type: "email" },
//             { label: "Phone", name: "phone", type: "text" },
//             { label: "Password", name: "password", type: "password" },
//             { label: "Date of Birth", name: "dob", type: "date" },
//             { label: "Date of Joining", name: "doj", type: "date" },
//             { label: "Designation", name: "designation", type: "text" },
//           ].map(({ label, name, type }) => (
//             <div key={name}>
//               <label className="block text-gray-700 font-medium mb-1">{label}</label>
//               <input
//                 type={type}
//                 name={name}
//                 value={formData[name]}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
//               />
//             </div>
//           ))}

//           {/* District Dropdown */}
//           <div>
//             <label className="block text-gray-700 font-medium mb-1">District</label>
//             <select
//               name="district_id"
//               value={formData.district_id}
//               onChange={handleDistrictChange}
//               required
//               className="w-full px-4 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select District</option>
//               {districts.map((district) => (
//                 <option key={district.id} value={district.id}>
//                   {district.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Municipality Dropdown */}
//           <div>
//             <label className="block text-gray-700 font-medium mb-1">Municipality</label>
//             <select
//               name="municipality_id"
//               value={formData.municipality_id}
//               onChange={handleMunicipalityChange}
//               required
//               className="w-full px-4 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select Municipality</option>
//               {municipalities
//                 .filter((m) => m.district_id === parseInt(formData.district_id))
//                 .map((m) => (
//                   <option key={m.id} value={m.id}>
//                     {m.name}
//                   </option>
//                 ))}
//             </select>
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             disabled={creating}
//             className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
//               creating ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
//             }`}
//           >
//             {creating ? "Creating..." : "Create User"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddUser;



// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { createUser } from "../redux/actions/UserActions";
// import { fetchDistricts, fetchMunicipalities } from "../redux/actions/locationActions";
// import { fetchDesignations } from "../redux/actions/designationActions"; // ✅ Import designation action

// const AddUser = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//     dob: "",
//     doj: "",
//     municipality: "",
//     municipality_id: "",
//     designation: "",
//     district: "",
//     district_id: "",
//   });

//   const dispatch = useDispatch();

//   const { creating, error } = useSelector((state) => state.User);
//   const { districts = [], municipalities = [] } = useSelector((state) => state.location || {});
//   const { designations = [] } = useSelector((state) => state.designation || {}); // ✅ Access designation list

//   useEffect(() => {
//     dispatch(fetchDistricts());
//     dispatch(fetchMunicipalities());
//     dispatch(fetchDesignations()); // ✅ Fetch designations
//   }, [dispatch]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleDistrictChange = (e) => {
//     const district_id = e.target.value;
//     const selected = districts.find((d) => d.id === parseInt(district_id));
//     setFormData((prev) => ({
//       ...prev,
//       district_id,
//       district: selected?.name || "",
//       municipality_id: "",
//       municipality: "",
//     }));
//   };

//   const handleMunicipalityChange = (e) => {
//     const municipality_id = e.target.value;
//     const selected = municipalities.find((m) => m.id === parseInt(municipality_id));
//     setFormData((prev) => ({
//       ...prev,
//       municipality_id,
//       municipality: selected?.name || "",
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(createUser(formData));
//   };

//   return (
//     <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
//       <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-lg">
//         <h1 className="text-2xl font-bold text-gray-800 mb-6">Add User</h1>

//         {error && (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
//             Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
//           {/* Standard Inputs */}
//           {[
//             { label: "Name", name: "name", type: "text" },
//             { label: "Email", name: "email", type: "email" },
//             { label: "Phone", name: "phone", type: "text" },
//             { label: "Password", name: "password", type: "password" },
//             { label: "Date of Birth", name: "dob", type: "date" },
//             { label: "Date of Joining", name: "doj", type: "date" },
//           ].map(({ label, name, type }) => (
//             <div key={name}>
//               <label className="block text-gray-700 font-medium mb-1">{label}</label>
//               <input
//                 type={type}
//                 name={name}
//                 value={formData[name]}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
//               />
//             </div>
//           ))}

//           {/* Designation Dropdown */}
//           <div>
//             <label className="block text-gray-700 font-medium mb-1">Designation</label>
//             <select
//               name="designation"
//               value={formData.designation}
//               onChange={handleChange}
//               required
//               className="w-full px-4 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select Designation</option>
//               {designations.map((desig, index) => (
//                 <option key={index} value={desig}>
//                   {desig}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* District Dropdown */}
//           <div>
//             <label className="block text-gray-700 font-medium mb-1">District</label>
//             <select
//               name="district_id"
//               value={formData.district_id}
//               onChange={handleDistrictChange}
//               required
//               className="w-full px-4 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select District</option>
//               {districts.map((district) => (
//                 <option key={district.id} value={district.id}>
//                   {district.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Municipality Dropdown */}
//           <div>
//             <label className="block text-gray-700 font-medium mb-1">Municipality</label>
//             <select
//               name="municipality_id"
//               value={formData.municipality_id}
//               onChange={handleMunicipalityChange}
//               required
//               className="w-full px-4 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select Municipality</option>
//               {municipalities
//                 .filter((m) => m.district_id === parseInt(formData.district_id))
//                 .map((m) => (
//                   <option key={m.id} value={m.id}>
//                     {m.name}
//                   </option>
//                 ))}
//             </select>
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             disabled={creating}
//             className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
//               creating ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
//             }`}
//           >
//             {creating ? "Creating..." : "Create User"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddUser;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUser } from "../redux/actions/UserActions";
import { fetchDistricts, fetchMunicipalities } from "../redux/actions/locationActions";
import { fetchDesignations } from "../redux/actions/designationActions";

const AddUser = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    dob: "",
    doj: "",
    municipality: "",
    municipality_id: "",
    designation: "",
    district: "",
    district_id: "",
  });

  const [formError, setFormError] = useState("");

  const dispatch = useDispatch();
  const { creating, error } = useSelector((state) => state.User);
  const { districts = [], municipalities = [] } = useSelector((state) => state.location || {});
  const { designations = [] } = useSelector((state) => state.designation || {});

  useEffect(() => {
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
    dispatch(fetchDesignations());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDistrictChange = (e) => {
    const district_id = e.target.value;
    const selected = districts.find((d) => d.id === parseInt(district_id));
    setFormData((prev) => ({
      ...prev,
      district_id,
      district: selected?.name || "",
      municipality_id: "",
      municipality: "",
    }));
  };

  const handleMunicipalityChange = (e) => {
    const municipality_id = e.target.value;
    const selected = municipalities.find((m) => m.id === parseInt(municipality_id));
    setFormData((prev) => ({
      ...prev,
      municipality_id,
      municipality: selected?.name || "",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Local phone number validation
    if (!/^\d{10}$/.test(formData.phone)) {
      setFormError("Phone number must be exactly 10 digits");
      return;
    }

    setFormError("");
    dispatch(createUser(formData));
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Add User</h1>

        {/* ✅ Show frontend or backend error */}
        {(formError || error) && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
            {formError || (typeof error === "string" ? error : error?.message || "Something went wrong")}
          </div>
        )}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          {[
            { label: "Name", name: "name", type: "text" },
            { label: "Email", name: "email", type: "email" },
            { label: "Phone", name: "phone", type: "text" },
            { label: "Password", name: "password", type: "password" },
            { label: "Date of Birth", name: "dob", type: "date" },
            { label: "Date of Joining", name: "doj", type: "date" },
          ].map(({ label, name, type }) => (
            <div key={name}>
              <label className="block text-gray-700 font-medium mb-1">{label}</label>
              <input
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
              />
            </div>
          ))}

          {/* Designation Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Designation</label>
            <select
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Select Designation</option>
              {designations.map((desig, index) => (
                <option key={index} value={desig}>
                  {desig}
                </option>
              ))}
            </select>
          </div>

          {/* District Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">District</label>
            <select
              name="district_id"
              value={formData.district_id}
              onChange={handleDistrictChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Select District</option>
              {districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.name}
                </option>
              ))}
            </select>
          </div>

          {/* Municipality Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Municipality</label>
            <select
              name="municipality_id"
              value={formData.municipality_id}
              onChange={handleMunicipalityChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Select Municipality</option>
              {municipalities
                .filter((m) => m.district_id === parseInt(formData.district_id))
                .map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
            </select>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={creating}
            className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
              creating ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {creating ? "Creating..." : "Create User"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
